import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home'
import Result from '@/views/Result'
import Index from '@/views/Index'
import Rule from '@/views/Rule'
Vue.use(VueRouter)

  const routes = [
    {
      path: '/Home',
      name: 'Home',
      component: Home,
    },
    {
      path: '/Result',
      name: 'Result',
      component: Result,
    },
    {
      path: '/',
      name: 'Index',
      component: Index,
    },
    {
      path: '/rule',
      name: 'Rule',
      component: Rule,
    }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'hash', // app必须为hash模式，否则白屏
  base: process.env.BASE_URL,
  routes
})

export default router
